import React from 'react';


export default function TableHeaderReporting() {
    return (
        <thead>
            <tr>
                <th className="store key">Magasin</th>
                <th className="date">Date</th>
                <th className="stat sent">Envoyés</th>
            </tr>
        </thead>
    );
}